export default __webpack_public_path__ + "static/media/Dr.Bruno_Meessen.7195dfd6.png";